import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import type { AuthSession } from '../../models/profile';
import { AuthService } from '../../../services/auth.service';
import type { UrlTree } from '@angular/router';
import { Router } from '@angular/router';

@Component({
  selector: 'app-redirect',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,  imports: [],
  templateUrl: './redirect.component.html',
  styleUrl: './redirect.component.scss',
})
export class RedirectComponent {
  private authService = inject(AuthService);
  private router = inject(Router);

  authToken: AuthSession | undefined;
  error = '';
  code = '';

  constructor() {
    this.redirect();
  }

  redirect(): UrlTree | void {
    const profile = this.authService.getProfile();
    if (!profile) {
      return this.router.parseUrl('/auth');
    }
    this.router.navigate(['/dashboard']);
  }
}
